import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCodeMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCodeMedium"><Path fillRule="evenodd" clipRule="evenodd" d="M7.80886 7.71799L3.77862 12.0001L7.80886 16.2822L6.71656 17.3103L1.71875 12.0001L6.71656 6.68994L7.80886 7.71799ZM17.2808 6.68994L22.2786 12.0001L17.2808 17.3103L16.1885 16.2822L20.2188 12.0001L16.1885 7.71799L17.2808 6.68994Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCodeMedium;
